import dynamic from 'next/dynamic'
import { AdvertisingSlot } from 'react-advertising'

import {
  FiltersAccordion,
  FiltersAccordionOrigin,
} from '@/components/srp/filters/FiltersAccordion/FiltersAccordion'
import {
  FiltersSidebarContainer,
  FiltersSidebarPanel,
  SkyscraperAdSlotContainer,
} from '@/components/srp/filters/FiltersSidebar/styled'
import { SrpLoading } from '@/components/srp/srp-loading'
import { SkyscraperAdSenseSrpContainer } from '@/components-page/srp/advertisement/SkyscraperAdsenseSrpContainer'
import { GPT_COMPONENT_ID } from '@/features/advertisement/constants/adSlots'
import { useAdsReinventionExperiment } from '@/hooks/srp/useAdsReinventionExperiment'
import { useShouldShowSrpAds } from '@/hooks/useShouldShowSrpAds'
import { RemoteParamKeys, useToggle } from '@/lib/firebase/hooks'
import { GA_SAVE_SEARCH_TYPES } from '@/lib/ga/constants/ga'

const SaveSearchChipButton = dynamic(
  () => import('@/components/srp/save-search-chip').then((mod) => mod.SaveSearchChipButton),
  { ssr: false }
)

export type FiltersSidebarProps = {
  isMobileForAds?: boolean
  isLoadingFilters?: boolean
  categoryId?: number
  shouldRenderMapSRP?: boolean
  isRadialSearch: boolean
}

export const FiltersSidebar = ({
  isMobileForAds,
  isLoadingFilters,
  isRadialSearch,
}: FiltersSidebarProps) => {
  const { shouldShowSrpAds } = useShouldShowSrpAds(isRadialSearch)

  const { isAdsReinventionExperimentEnabled, adsReinventionExperimentGroup } =
    useAdsReinventionExperiment(isMobileForAds)

  const saveSearchWithinFiltersDecision = useToggle(RemoteParamKeys.SAVED_SEARCH_WITHIN_FILTERS)

  const renderFiltersSidebarPanel = () => {
    if (
      isAdsReinventionExperimentEnabled &&
      adsReinventionExperimentGroup === 2 &&
      shouldShowSrpAds
    ) {
      return null
    }

    return (
      <FiltersSidebarPanel data-testid="srp-desktop-filter">
        {saveSearchWithinFiltersDecision?.enabled && (
          <SaveSearchChipButton eventTrackingSource={GA_SAVE_SEARCH_TYPES.btn} />
        )}
        {isLoadingFilters ? (
          <SrpLoading variant={'sidebar-filter-simplified'} />
        ) : (
          <FiltersAccordion isSimplified origin={FiltersAccordionOrigin.SIDE_PANEL} />
        )}
      </FiltersSidebarPanel>
    )
  }

  return (
    <FiltersSidebarContainer
      adsReinventionExperimentGroup={adsReinventionExperimentGroup}
      isAdsReinventionExperimentEnabled={isAdsReinventionExperimentEnabled && shouldShowSrpAds}
    >
      {renderFiltersSidebarPanel()}

      {shouldShowSrpAds && !isMobileForAds && (
        <>
          <SkyscraperAdSenseSrpContainer
            id="AFSTop"
            isAdsReinventionExperimentEnabled={isAdsReinventionExperimentEnabled}
            adsReinventionExperimentGroup={adsReinventionExperimentGroup}
          />
          <SkyscraperAdSlotContainer>
            <AdvertisingSlot
              id={GPT_COMPONENT_ID.SKYSCRAPER}
              data-testid={GPT_COMPONENT_ID.SKYSCRAPER}
            />
          </SkyscraperAdSlotContainer>
        </>
      )}
    </FiltersSidebarContainer>
  )
}
